import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChatProvider } from './context/ChatContext';
import { PigRainOverlay } from './components/PigRainOverlay';
import { MessageAlertHost } from './components/MessageAlertHost';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import reportWebVitals from './reportWebVitals';

// Runtime build marker for debugging "which frontend is running"
(window as any).__chatBuildTag = 'chat-app-client-v6';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChatProvider>
      <App />
      <MessageAlertHost />
      <PigRainOverlay />
      <Analytics />
      <SpeedInsights />
    </ChatProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
